import gql from 'graphql-tag';

const CAMPAIGN_ORDERS_AGGREGATE_BYDATE = gql`
  query campaignOrdersAggregateByDate($where: CampaignOrderWhereInput!) {
    campaignOrders(where: $where) {
      id
      name
      startDate
      endDate
      IONumber
      productCode
      type
      complianceAudiences {
            id
            name
            geoTargets {
            id
            name
            location {
              id
              name
              formattedAddress
              street
              state
              city
              zip
              lat
              lng
              country
              county
              licenses {
                designations
              }
            }
            polygons {
              geometry
            }
            circles {
              radius
              coordinate {
                lat
                lng
              }
              location {
                id
                name
                formattedAddress
                zip
                street
                city
                county
                state
                country
                lat
                lng
              }
            }
          }
          }
      advertiser {
        id
        name
        CPAcronym
        level
        cpm
        parentOrg {
          id
          CPAcronym
          level
          createdAt
        }
        
      }
      campaigns (first: 1) {
        id
        cpm
      }
      cpm
      aggregateData {
        id
        completeAttributionSummary
      }
    }
  }
`;

export default CAMPAIGN_ORDERS_AGGREGATE_BYDATE;
